import React from 'react';
import { MessageSquareIcon, PhoneIcon } from 'lucide-react';
import { business } from '../data/site';
export function MobileCallBar() {
  return <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-px bg-navy-950 pb-[env(safe-area-inset-bottom)] lg:hidden" data-id="element-240" data-mp="2sbv16furx56t">
      <a href={business.tel} className="flex min-h-[60px] items-center justify-center gap-2 bg-navy text-base font-bold text-white active:bg-navy-600" data-id="element-241" data-mp="2ie6v4trpwb9c">
        <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-242" data-mp="24kz7fd6rbzwx" />
        Call
      </a>
      <a href={business.sms} className="flex min-h-[60px] items-center justify-center gap-2 bg-water text-base font-bold text-navy-950 active:bg-water-300" data-id="element-243" data-mp="29f3b9nkq7rts">
        <MessageSquareIcon className="h-5 w-5" aria-hidden="true" data-id="element-244" data-mp="1zoqvs9rrqoui" />
        Text Us
      </a>
    </div>;
}